import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import type { RootState } from '../store';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, loading, bootstrapped } = useSelector((state: RootState) => state.auth);
  const location = useLocation();

  // Wait while the session is being restored (tryAutoLogin) or any auth request is
  // in flight. Without this, a full page load of a protected route would redirect to
  // /login before the stored session is restored. We gate only when `bootstrapped`
  // is explicitly false (the real app's initial state) so a preloaded store that
  // omits the flag still renders immediately.
  if (loading || bootstrapped === false) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary-500"></div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Render children if authenticated
  return <>{children}</>;
};

export default ProtectedRoute;
